import PropTypes from 'prop-types';
import * as Styled from './ClientChoice.styles';

export const ClientChoice  = ()=> {
  return (
   <Styled.Container>
       <Styled.ClientDescription>Wybór klientów</Styled.ClientDescription>
    </Styled.Container>
  );
};

ClientChoice.propTypes = {
  planName: PropTypes.string  
};
